export const FIELD_CLASSES =
  'flex h-10 max-w-full items-center gap-2 rounded-lg border border-theme-border-medium bg-theme-modal px-3 text-[14px] text-theme-text-primary transition-colors focus-within:border-theme-accent-primary focus-within:shadow-[0_0_0_3px_color-mix(in_srgb,var(--theme-accent-primary)_15%,transparent)] [@media(pointer:coarse)]:text-[16px]';

// Widths are given for the 14px text and grow with the 16px text on touch screens.
export const fieldWidth = (px: number): string => `${px / 14}em`;
